import Link from 'next/link';
import styled from 'styled-components';

export const LinkNext = styled(Link)`
  &:active,
  &:focus,
  &:hover {
    background-color: ${({ theme }) =>
      theme.colors.neutral['neutral_alpha']['3']};
    border-radius: ${({ theme }) => theme.radius['3']}px;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;

  gap: ${({ theme }) => theme.spacing['4']}px;
`;

export const ProdutoInfo = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  gap: ${({ theme }) => theme.spacing['2']}px;
`;

export const ProdutoDescricao = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;

  align-items: center;
  justify-content: space-between;
`;

export const TextoPromocional = styled.p`
  text-decoration-line: line-through;
  color: ${({ theme }) => theme.colors.neutral.neutral_alpha[11]};
  font-weight: ${({ theme }) => theme.typography.font.weight.medium};
`;

export const ContainterPrecoComDescont = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing[2]}px;
`;
